module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Sport4-27dfeecbc286ac8aa452a1039434c89d.png";